
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.$nextTick(() => {
      // this.initAnimation()
      this.initAnim()
    })
  },
  methods: {
    initAnim() {
      const mm = this.$gsap.matchMedia(this.$refs.container)

      mm.add('(min-width: 1024px)', () => {
        this.$gsap.to(
          '.square4',
          {
            rotation: 360,
            duration: 160,
            repeat: -1,
            ease: 'linear',
          },
          0
        )

        this.$gsap
          .timeline({
            scrollTrigger: {
              trigger: this.$refs.container,
              start: 'top bottom',
              end: 'bottom top',
              scrub: true,
              // markers: true,
            },
          })
          .from('.square1', {
            scale: 1.1,
            x: -120,
            y: -40,
            rotate: 45,
            duration: 0.5,
            ease: 'back(.5)',
          })
          .from(
            '.square2',
            {
              scale: 0.8,
              x: 150,
              y: -70,
              rotate: 60,
              duration: 0.5,
              ease: 'back(.5)',
            },
            0
          )
          .from(
            '.square3',
            {
              scale: 1.1,
              x: 100,
              y: 150,
              rotate: 90,
              duration: 0.5,
              ease: 'back(.5)',
            },
            0
          )
      })
    },
    initAnimation() {
      const mm = this.$gsap.matchMedia()
      const q = this.$gsap.utils.selector(this.$el)

      mm.add(
        '(min-width: 1024px)',
        () => {
          const tweenProperty = (target, prop, min, max) => {
            const randomDur = this.$gsap.utils.random(3, 6, 0.2, true)
            const randomDelay = this.$gsap.utils.random(0.6, 2, 0.2, true)

            this.$gsap.to(target, {
              scrollTrigger: {
                trigger: this.$refs.container,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
                markers: true,
              },
              [prop]: this.$gsap.utils.random(min, max),
              duration: randomDur(),
              delay: randomDelay(),
              ease: 'none',
              onComplete: tweenProperty,
              onCompleteParams: [target, prop, min, max],
            })
          }
          // Animate the properties individually
          this.$gsap.utils.toArray(q('.square')).forEach((star) => {
            tweenProperty(star, 'rotate', -15, 15)
            tweenProperty(star, 'scale', 0.8, 1.1)
            tweenProperty(star, 'x', -40, 20)
            tweenProperty(star, 'y', -40, 20)
          })
        },
        this.$refs.imgContainer
      )

      mm.add(
        '(max-width: 1023px)',
        () => {
          const tweenProperty = (target, prop, min, max) => {
            const randomDur = this.$gsap.utils.random(3, 6, 0.2, true)
            const randomDelay = this.$gsap.utils.random(0.6, 2, 0.2, true)

            this.$gsap.to(target, {
              [prop]: this.$gsap.utils.random(min, max),
              duration: randomDur(),
              delay: randomDelay(),
              ease: 'none',
              onComplete: tweenProperty,
              onCompleteParams: [target, prop, min, max],
            })
          }
          // Animate the properties individually
          this.$gsap.utils.toArray(q('.square')).forEach((star) => {
            tweenProperty(star, 'rotate', -15, 15)
            tweenProperty(star, 'scale', 0.6, 1.1)
            tweenProperty(star, 'x', -10, 10)
            tweenProperty(star, 'y', -10, 10)
          })
        },
        this.$refs.imgContainer
      )
    },
  },
}
